module.exports = __webpack_public_path__ + "img/triangle-20.46a6729a.gif";